import React, { useEffect, useState} from 'react';
import { Box, Divider, Drawer, IconButton, List, ListItem, Typography, Button, TextField } from '@mui/material';
import DeleteIcon from "@mui/icons-material/Delete";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { collection, query, where, getDocs, onSnapshot, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";
const drawerWidth = 300;

export default function Cart({ cart = [], 
  setCart, openCartDrawer, toggleCartDrawer, isMobile, navigate, 
  setCartMarginAdjustment, tableId, companyCode, companyName, isPureVeg, 
  unitCode, updateCartInFirestore,
  cartId, serviceArea }) {
  console.log('Cart: Props received:', { 
    cart: cart.map(item => ({ id: item.id, name: item.name, quantity: item.quantity, totalPrice: item.totalPrice, cookingInstructions: item.cookingInstructions })), 
    openCartDrawer, 
    isMobile, 
    tableId, 
    companyCode, 
    companyName, 
    isPureVeg,
    unitCode,
    cartId,
    serviceArea
  });

  const [isOrdering, setIsOrdering] = useState(false);
  const [orderedItems, setOrderedItems] = useState([]);
  //const lastSyncedCartRef = React.useRef([]);
  const isSyncingFromFirestore = React.useRef(false);
/*useEffect(() => {
  if (
    cartId &&
    typeof updateCartInFirestore === "function" &&
    !isOrdering &&
    cart.length > 0 
  ) {
    updateCartInFirestore(cart);
  }
}, [cart, cartId, isOrdering]);*/
useEffect(() => {
  if (
    cartId &&
    typeof updateCartInFirestore === "function" &&
    !isOrdering &&
    cart.length > 0 &&
    !isSyncingFromFirestore.current 
  ) {
    updateCartInFirestore(cart);
  }
}, [cart, cartId, isOrdering]);

  /*const removeFromCart = (id) => {
    console.log('Cart: Removing item:', id, 'Current cart:', cart.map(item => ({ id: item.id, name: item.name, quantity: item.quantity, totalPrice: item.totalPrice, cookingInstructions: item.cookingInstructions })));
    setCart(prevCart => {
      const updatedCart = prevCart.filter(item => item.id !== id);
      console.log('Cart: Updated cart after removal:', updatedCart.map(item => ({ id: item.id, name: item.name, quantity: item.quantity, totalPrice: item.totalPrice, cookingInstructions: item.cookingInstructions })));
      return updatedCart;
    });
  };*/
  const removeFromCart = (id) => {
  setCart(prevCart => {
    const updatedCart = prevCart.filter(item => item.id !== id);

    if (typeof updateCartInFirestore === "function") {
      updateCartInFirestore(updatedCart); 
    }

    return updatedCart;
  });
};
  const hasCartItems = cart.length > 0;
const allServed =
  orderedItems.length > 0 &&
  orderedItems.every(item => item.status === "Served");

  /*const updateQuantity = (id, change) => {
    console.log('Cart: Updating quantity for item:', id, 'Change:', change);
    setCart(prevCart => {
      const updatedCart = prevCart.map(item => {
        if (item.id === id) {
          const newQuantity = item.quantity + change;
          if (newQuantity <= 0) return null; // Will be filtered out
          return {
            ...item,
            quantity: newQuantity,
            totalPrice: newQuantity * item.price
          };
        }
        return item;
      }).filter(item => item !== null);
      console.log('Cart: Updated cart with new quantity:', updatedCart.map(item => ({ id: item.id, name: item.name, quantity: item.quantity, totalPrice: item.totalPrice, cookingInstructions: item.cookingInstructions })));
      return updatedCart;
    });
  };*/
/*const updateQuantity = (id, change) => {
  setCart(prevCart => {
    const updatedCart = prevCart
      .map(item => {
        if (item.id === id) {
          const newQuantity = item.quantity + change;
          if (newQuantity <= 0) return null;

          return {
            ...item,
            quantity: newQuantity,
            totalPrice: newQuantity * item.price
          };
        }
        return item;
      })
      .filter(item => item !== null);

    if (typeof updateCartInFirestore === "function") {
      updateCartInFirestore(updatedCart);
    }

    return updatedCart;
  });
};*/

const updateQuantity = (id, change) => {
  setCart(prevCart => {
    const updatedCart = prevCart
      .map(item => {
        if (item.id === id) {
          const newQuantity = item.quantity + change;
          if (newQuantity <= 0) return null;

          return {
            ...item,
            quantity: newQuantity,
            totalPrice: newQuantity * item.price 
          };
        }
        return item;
      })
      .filter(item => item !== null);

    if (typeof updateCartInFirestore === "function") {
      updateCartInFirestore(updatedCart);
    }


    return updatedCart;
  });
};

  const updateCookingInstructions = (id, instructions) => {
    console.log('Cart: Updating cooking instructions for item:', id, 'Instructions:', instructions);
    /*setCart(prevCart => {
      const updatedCart = prevCart.map(item =>
        item.id === id ? { ...item, cookingInstructions: instructions } : item
      );
      console.log('Cart: Updated cart with cooking instructions:', updatedCart.map(item => ({ id: item.id, name: item.name, quantity: item.quantity, totalPrice: item.totalPrice, cookingInstructions: item.cookingInstructions })));
      return updatedCart;
    });*/
    setCart(prevCart => {
  const updatedCart = prevCart.map(item =>
    item.id === id ? { ...item, cookingInstructions: instructions } : item
  );

  /*if (typeof updateCartInFirestore === "function") {
    updateCartInFirestore(updatedCart);
  }*/

  return updatedCart;
});
  };

  //const totalPrice = cart.reduce((total, item) => total + (item.totalPrice || 0), 0);
  const cartTotal = cart.reduce(
  (total, item) => total + (item.totalPrice || 0),
  0
);

const orderedTotal = orderedItems.reduce(
  (total, item) => total + (item.totalPrice || 0),
  0
);

const totalPrice = cartTotal + orderedTotal;

/*useEffect(() => {
  const fetchCart = async () => {
    if (!cartId) return;

    const cartQuery = query(
      collection(db, "carts"),
      where("cartId", "==", cartId)
    );

    const snapshot = await getDocs(cartQuery);

    if (!snapshot.empty) {
      const data = snapshot.docs[0].data();
      const items = data.items || [];

      const orderedStatuses = ["Ordered", "Confirmed", "Preparing", "Ready", "Served"];

      setCart(items.filter(item => !orderedStatuses.includes(item.status)));
      setOrderedItems(items.filter(item => orderedStatuses.includes(item.status)));
    }
  };

  fetchCart();
}, [cartId, isOrdering]);*/
const prevItemsRef = React.useRef([]);

/*useEffect(() => {
  if (!cartId) return;

  const cartQuery = query(
    collection(db, "carts"),
    where("cartId", "==", cartId)
  );

  const unsubscribe = onSnapshot(cartQuery, (snapshot) => {
    if (!snapshot.empty) {
      const data = snapshot.docs[0].data();
      const items = data.items || [];

      // Prevent unnecessary updates
      if (JSON.stringify(prevItemsRef.current) === JSON.stringify(items)) {
        return;
      }

      prevItemsRef.current = items;

      const orderedStatuses = ["Ordered", "Confirmed", "Preparing", "Ready", "Served"];

      setCart(items.filter(item => !orderedStatuses.includes(item.status)));
      setOrderedItems(items.filter(item => orderedStatuses.includes(item.status)));
    }
  });

  return () => unsubscribe();
}, [cartId]);*/

/*useEffect(() => {
  if (!cartId) return;

  const cartQuery = query(
    collection(db, "carts"),
    where("cartId", "==", cartId)
  );

  const unsubscribe = onSnapshot(cartQuery, (snapshot) => {
    
    // if cart is deleted → redirect
    if (snapshot.empty) {
      console.log("Cart deleted → redirecting to login");

      setCart([]);
      setOrderedItems([]);

      navigate("/employee-login");
      return;
    }

    // existing logic
    const data = snapshot.docs[0].data();
    const items = data.items || [];

    if (JSON.stringify(prevItemsRef.current) === JSON.stringify(items)) {
      return;
    }

    prevItemsRef.current = items;

    const orderedStatuses = ["Ordered", "Confirmed", "Preparing", "Ready", "Served"];

    setCart(items.filter(item => !orderedStatuses.includes(item.status)));
    setOrderedItems(items.filter(item => orderedStatuses.includes(item.status)));
  });

  return () => unsubscribe();
}, [cartId]);*/

useEffect(() => {
  if (!cartId) return;

  const cartQuery = query(
    collection(db, "carts"),
    where("cartId", "==", cartId)
  );

  const unsubscribe = onSnapshot(cartQuery, (snapshot) => {
    if (snapshot.empty) {
      setCart([]);
      setOrderedItems([]);
      navigate("/employee-login");
      return;
    }

    const data = snapshot.docs[0].data();
    const items = data.items || [];

    // prevent unnecessary updates
    if (JSON.stringify(prevItemsRef.current) === JSON.stringify(items)) {
      return;
    }

    prevItemsRef.current = items;

    const orderedStatuses = ["Ordered", "Confirmed", "Preparing", "Ready", "Served"];

    // MARK AS SYNCING
    isSyncingFromFirestore.current = true;

    setCart(items.filter(item => !orderedStatuses.includes(item.status)));
    setOrderedItems(items.filter(item => orderedStatuses.includes(item.status)));

    // small delay to release lock
    setTimeout(() => {
      isSyncingFromFirestore.current = false;
    }, 100);
  });

  return () => unsubscribe();
}, [cartId]);

 const handlePlaceOrder = async () => {
  try {
    if (!cartId || cart.length === 0) return;

    setIsOrdering(true);

    //  Get server assigned to this serviceArea
/*const serverQuery = query(
  collection(db, "users"),
  where("role", "==", "servers"),
  where("companyCode", "==", companyCode),
  where("unitCode", "==", unitCode),
  //where("serviceArea", "==", serviceArea)
);

const serverSnapshot = await getDocs(serverQuery);

let assignedServerId = null;

if (!serverSnapshot.empty) {
  const serverData = serverSnapshot.docs[0].data();
  assignedServerId = serverData.userId;
  console.log("ASSIGNED SERVER:", assignedServerId);
}*/
const serverBaseQuery = query(
  collection(db, "users"),
  where("role", "==", "servers"),
  where("companyCode", "==", companyCode),
  where("unitCode", "==", unitCode)
);

const serverSnapshot = await getDocs(serverBaseQuery);

let assignedServerId = null;

if (!serverSnapshot.empty) {
  const servers = serverSnapshot.docs.map(doc => doc.data());

  // exact match on serviceArea
  let matchedServer = servers.find(
    s => s.serviceArea === serviceArea
  );

  if (!matchedServer) {
    matchedServer = servers[0];
  }

  assignedServerId = matchedServer?.userId || null;

  console.log("ASSIGNED SERVER:", assignedServerId);
}
    const orderedItems = cart.map(item => ({
      ...item,
      status: "Ordered",
      serviceArea,
      tableId,
      unitCode,
      companyCode,
      assignedServerId 
    }));

    await updateCartInFirestore(orderedItems, {
      cartStatus: "Ordered",
       assignedServerId, 
      updatedAt: serverTimestamp()
    });

    // ✅ Clear UI AFTER update
    setCart([]);
    //setOrderedItems(prev => [...prev, ...orderedItems]); 
    //setCart(orderedItems);
    toggleCartDrawer();
       // 🔹 Navigate to cart/order page to show the ordered items
    navigate(`/customer/menu?code=${companyCode}&unit=${unitCode}&id=${tableId}&serviceArea=${serviceArea}&cartId=${cartId}`, {
      state: { companyCode, unitCode, tableId, serviceArea, cartId }
    });

  } catch (error) {
    console.error("Order error:", error);
  } finally {
    setTimeout(() => {
      setIsOrdering(false); // ✅ prevents overwrite
    }, 300);
  }
};


  const handleProceedToCheckout = () => {
    if (!companyCode) {
      alert('Company code is missing. Please scan a valid QR code (e.g., /customer/menu?code=ss&unit=ssu1ma&id=T1).');
      return;
    }
    if (!unitCode) {
      alert('Unit code is missing. Please scan a valid QR code (e.g., /customer/menu?code=ss&unit=ssu1ma&id=T1).');
      return;
    }
    if (!tableId) {
      alert('Table ID is missing. Please scan a valid QR code (e.g., /customer/menu?code=ss&unit=ssu1ma&id=T1).');
      return;
    }
    if (cart.length === 0) {
      alert('Your cart is empty!');
      return;
    }
    console.log('Cart: Navigating to order with state:', { 
      cart: cart.map(item => ({ id: item.id, name: item.name, quantity: item.quantity, totalPrice: item.totalPrice, cookingInstructions: item.cookingInstructions })), 
      companyCode, 
      unitCode,
      tableId, 
      totalAmount: totalPrice,
      companyName,
      isPureVeg
    });
    toggleCartDrawer();
    navigate(`/customer/order?code=${companyCode}&unit=${unitCode}&id=${tableId}`, { 
      state: { cart, totalAmount: totalPrice, tableId, companyCode, unitCode, companyName, isPureVeg }
    });
  };

  if (!companyCode || !unitCode || !tableId) {
    return (
      <Drawer
        variant={isMobile ? "temporary" : "persistent"}
        anchor="right"
        open={openCartDrawer}
        onClose={isMobile ? toggleCartDrawer : undefined}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          zIndex: 1200,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            top: '72px',
            height: 'calc(100% - 72px)',
            transition: (theme) =>
              theme.transitions.create(['width'], {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.standard,
              }),
          },
        }}
      >
        <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', height: '100%' }}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h6">Your Cart</Typography>
            <IconButton onClick={toggleCartDrawer}>
              <ShoppingCartIcon fontSize="small" />
            </IconButton>
          </Box>
          <Typography variant="body1" color="text.secondary" sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            Please scan a QR code to add items to your cart.
          </Typography>
        </Box>
      </Drawer>
    );
  }

  return (
    <Drawer
      variant={isMobile ? "temporary" : "persistent"}
      anchor="right"
      open={openCartDrawer}
      onClose={isMobile ? toggleCartDrawer : undefined}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        zIndex: 1200,
        '& .MuiDrawer-paper': {
          width: isMobile ? '80%' : drawerWidth,
          boxSizing: 'border-box',
          top: '72px',
          height: 'calc(100% - 72px)',
          transition: (theme) =>
            theme.transitions.create(['width'], {
              easing: theme.transitions.easing.easeInOut,
              duration: theme.transitions.duration.standard,
            }),
        },
      }}
    >
      <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h6">Your Cart ({cart.length} items)</Typography>
          <IconButton onClick={toggleCartDrawer}>
            <ShoppingCartIcon fontSize="small" />
          </IconButton>
        </Box>
        <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
  OTP: {cartId || "----"}
</Typography>
        <Typography variant="h8">Table ID: {tableId}</Typography>
        <Typography variant="h8">Unit: {unitCode}</Typography>
{orderedItems.length > 0 && (
  <>
    {/*<Divider sx={{ my: 2 }} />

    
    <Typography 
      variant="subtitle1" 
      sx={{ textAlign: "center", fontWeight: "bold", mb: 1 }}
    >
      Ordered Items
    </Typography>

    {orderedItems.map(item => (
      <Box
        key={item.id}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 1,
          px: 1
        }}
      >
       
        <Typography sx={{ fontSize: "0.85rem" }}>
          {item.name} ({item.quantity})
        </Typography>

       
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography sx={{ fontSize: "0.85rem" }}>
            ₹{item.totalPrice.toFixed(2)}
          </Typography>

          
          <Box
            sx={{
              px: 1,
              py: "2px",
              borderRadius: "10px",
              fontSize: "0.7rem",
              color: "white",
              backgroundColor:
                item.status === "Ordered"
                  ? "lightgray"
                  : item.status === "Preparing"
                  ? "orange"
                  : item.status === "Ready"
                  ? "lightgreen"
                  : item.status === "Served"
                  ? "darkgreen"
                  : "blue"
            }}
          >
            {item.status || "Ordered"}
          </Box>
        </Box>
      </Box>
    ))}*/}
    <Box sx={{ mb: 1 }}>
  <Typography
    variant="subtitle1"
    sx={{ textAlign: "center", fontWeight: "bold" }}
  >
    Ordered Items
  </Typography>

  <Box
    sx={{
      maxHeight: '20vh',
      overflowY: 'auto',
      pr: 1,
      mb: 1
    }}
  >
    {orderedItems.map(item => (
      <Box
        key={item.id}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: 1,
          px: 1
        }}
      >
        <Typography sx={{ fontSize: "0.85rem" }}>
          {item.name} ({item.quantity})
        </Typography>

        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <Typography sx={{ fontSize: "0.85rem" }}>
            ₹{item.totalPrice.toFixed(2)}
          </Typography>

          <Box
            sx={{
              px: 1,
              borderRadius: "10px",
              fontSize: "0.7rem",
              color: "white",
              backgroundColor:
                item.status === "Preparing"
                  ? "orange"
                  : item.status === "Ready"
                  ? "green"
                  : item.status === "Served"
                  ? "darkgreen"
                  : "gray"
            }}
          >
            {item.status}
          </Box>
        </Box>
      </Box>
    ))}
  </Box>
</Box>
  </>
  
)}

        {cart.length === 0 && orderedItems.length === 0 ? (
  <Typography
    color="text.secondary"
    sx={{
      flexGrow: 1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    Cart is empty
  </Typography>
) : (
  <>
            <List sx={{ flexGrow: 1, overflowY: 'auto' }}>
              {cart.map((item, index) => (
                <React.Fragment key={item.id}>
                  <ListItem
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-start',
                      py: 1
                    }}
                  >
                    <Box>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: '0.9rem',
                            flex: 1,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                          }}
                        >
                          {item.name} (x{item.quantity})
                        </Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                        <IconButton
                          size="small"
                          color="primary"
                          onClick={() => updateQuantity(item.id, -1)}
                          sx={{ p: 0.5 }}
                        >
                          <RemoveIcon fontSize="small" />
                        </IconButton>
                        <Typography sx={{ fontSize: '0.9rem', fontWeight: 'bold' }}>
                          {item.quantity}
                        </Typography>
                        <IconButton
                          size="small"
                          color="primary"
                          onClick={() => updateQuantity(item.id, 1)}
                          sx={{ p: 0.5 }}
                        >
                          <AddIcon fontSize="small" />
                        </IconButton>
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: '0.85rem',
                            mx: 1,
                            minWidth: '60px',
                            textAlign: 'center'
                          }}
                        >
                          ₹{item.totalPrice.toFixed(2)}
                        </Typography>
                        <IconButton
                          color="error"
                          onClick={() => removeFromCart(item.id)}
                          sx={{ p: 0.5 }}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </Box>
                    <TextField
                      value={item.cookingInstructions || ''}
                      onChange={(e) => updateCookingInstructions(item.id, e.target.value)}
                      size="small"
                      fullWidth
                      sx={{ mt: 1, fontSize: '0.8rem' }}
                      inputProps={{ maxLength: 100 }}
                      placeholder="Cooking Instructions"
                    />
                  </ListItem>
                  {index < cart.length - 1 && (
                    <Divider sx={{ borderColor: 'rgba(0, 0, 0, 0.12)', my: 1 }} />
                  )}
                </React.Fragment>
              ))}
            </List>
            <Box sx={{ mt: 'auto' }}>
              <Divider sx={{ my: 2 }} />
              <Typography variant="h6" sx={{ fontSize: '1rem', mb: 2 }}>
                Total: ₹{totalPrice.toFixed(2)}
              </Typography>
              {/*<Button
                variant="contained"
                color="primary"
                fullWidth
                sx={{ fontSize: '0.9rem' }}
                //onClick={handleProceedToCheckout}
                onClick={handlePlaceOrder}
                disabled={!companyCode || !unitCode || !tableId || cart.length === 0 ||  cart.every(item => item.status === "Ordered")}
              >
                Proceed to Checkout
              </Button>*/}
             {hasCartItems ? (
  <Button
    variant="contained"
    color="primary"
    fullWidth
    sx={{ fontSize: '0.9rem' }}
    onClick={handlePlaceOrder}
  >
    Request Order
  </Button>
) : allServed ? (
  <Button
    variant="contained"
    color="success"
    fullWidth
    sx={{ fontSize: '0.9rem' }}onClick={() => {
      const servedTotal = orderedItems.reduce(
        (sum, item) => sum + (item.totalPrice || 0),
        0
      );

      // Get orderId from the first ordered item (all items in same cart should have same orderId)
      const orderId = orderedItems[0]?.orderId;
       console.log("Cart: orderId for payment navigation:", orderId);
      
       // Close cart drawer
  toggleCartDrawer();

      navigate(
        `/customer/payment?code=${companyCode}&unit=${unitCode}&id=${tableId}&cartId=${cartId}&serviceArea=${serviceArea}`,
        {
          state: { 
            orderedItems,
            companyCode,
            unitCode,
            tableId, 
            totalAmount: servedTotal,
            serviceArea,
            cartId,
            orderId // pass orderId here
          }
        }
      );
    }}
  >
    Pay
  </Button>
) : null}
            </Box>
          </>
        )}
      </Box>
    </Drawer>
  );
}